import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { Paratesto } from "../../types"
import ParatestoForm from "./ParatestoForm"
import { Button } from "@inmagik/magik-ui"
import { initialValuesParatesto, validationSchemaParatesto } from "./ParatestoCommon"

export default function ParatestoModal({
  title,
  paratesto,
  save,
  show,
  onClose,
  showEdizione = false,
  defaultTipologia,
  defaultOrdine,
}: {
  title: string
  paratesto?: Paratesto
  save: (values: Paratesto, actions: { setErrors: (errors: any) => void }) => Promise<void>
  show: boolean
  onClose: () => void
  showEdizione?: boolean
  defaultTipologia?: Paratesto["tipologia"]
  defaultOrdine?: Paratesto["ordine"]
}) {
  return (
    <Formik
      enableReinitialize
      initialValues={initialValuesParatesto(paratesto, defaultTipologia, defaultOrdine) as Paratesto}
      validationSchema={validationSchemaParatesto(showEdizione)}
      onSubmit={save}
    >
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <ParatestoForm col={12} showEdizione={showEdizione} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
